import { isToday } from 'date-fns';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';
import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

export const transformFieldLabel = ({ label }: RefinementListItem) => {
	const utcDate = toZonedTime(Number(label), 'UTC');
	if (isToday(utcDate)) {
		return 'Today';
	} else {
		return formatInTimeZone(Number(label), 'UTC', 'iii, MMM d');
	}
};
